import { useCallback, useRef } from 'react';

type TUnsubscribe = () => void;
type TDraftChangeListener = () => void;

const useDraftChangeNotifier = () => {
  const listenersRef = useRef<Set<TDraftChangeListener>>(new Set());

  const notifyDraftChanged = useCallback((): void => {
    listenersRef.current.forEach((listener) => listener());
  }, []);

  const subscribeToDraftChanges = useCallback((listener: TDraftChangeListener): TUnsubscribe => {
    listenersRef.current.add(listener);
    return () => { listenersRef.current.delete(listener); };
  }, []);

  return { notifyDraftChanged, subscribeToDraftChanges };
};

export default useDraftChangeNotifier;
